import { render, staticRenderFns } from "./ChatBotDemoMessage.vue?vue&type=template&id=4fa92c5c&scoped=true&"
import script from "./ChatBotDemoMessage.vue?vue&type=script&lang=js&"
export * from "./ChatBotDemoMessage.vue?vue&type=script&lang=js&"
import style0 from "./ChatBotDemoMessage.vue?vue&type=style&index=0&id=4fa92c5c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa92c5c",
  null
  
)

export default component.exports